module.exports = __webpack_public_path__ + "img/infra.676a7901.svg";